export const API_URL = process.env.REACT_APP_API_URL
export const CHARGEBEE_SITE =
  process.env.NODE_ENV === 'production' ? 'shopandshout' : 'shopandshout-test'
export const IDM_URL = process.env.REACT_APP_IDM_URL
export const AUTH_DASHBOARD_DOMAIN = process.env.REACT_APP_AUTH_DASHBOARD_DOMAIN
export const HELP_CENTER_URL = 'https://creator8882.zendesk.com/hc/en-us'
